import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=3afb38dc&scoped=true&"
import script from "./operation.vue?vue&type=script&lang=js&"
export * from "./operation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb38dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afb38dc')) {
      api.createRecord('3afb38dc', component.options)
    } else {
      api.reload('3afb38dc', component.options)
    }
    module.hot.accept("./operation.vue?vue&type=template&id=3afb38dc&scoped=true&", function () {
      api.rerender('3afb38dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/operation.vue"
export default component.exports